import Vue from 'vue';
import Router from 'vue-router';

const Home = () => import(/* webpackChunkName: "home" */ '@pages/index.vue');
const Auth = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/index.vue');
const Help = () =>
  import(/* webpackChunkName: "help" */ '@pages/help/index.vue');
const Mypage = () =>
  import(/* webpackChunkName: "mypage" */ '@pages/mypage.vue');
const Video = () => import(/* webpackChunkName: "video" */ '@pages/video.vue');
const Terms = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/terms.vue');
const SignUp = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/signup.vue');
const Login = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/login.vue');
const FindId = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/find-id.vue');
const FindIdResult = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/find-id-result.vue');
const FindPassword = () =>
  import(/* webpackChunkName: "auth" */ '@pages/auth/find-password.vue');
const Policy = () =>
  import(/* webpackChunkName: "mypage" */ '@pages/help/policy.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/login',
      redirect: '/auth/login',
    },
    {
      path: '/signup',
      redirect: '/auth/signup',
    },
    {
      path: '/terms',
      redirect: '/auth/terms',
    },
    {
      path: '/find-id',
      redirect: '/auth/find-id',
    },
    {
      path: '/find-id-result',
      redirect: '/auth/find-id-result',
    },
    {
      path: '/find-password',
      redirect: '/auth/find-password',
    },
    {
      path: '/auth',
      name: 'Auth',
      component: Auth,
      redirect: '/auth/login',
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login,
        },
        {
          path: 'signup',
          name: 'Signup',
          component: SignUp,
        },
        {
          path: 'terms',
          name: 'Terms',
          component: Terms,
        },
        {
          path: 'find-id',
          name: 'FindId',
          component: FindId,
        },
        {
          path: 'find-id-result',
          name: 'FindIdResult',
          component: FindIdResult,
        },
        {
          path: 'find-password',
          name: 'FindPassword',
          component: FindPassword,
        },
      ],
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      children: [
        {
          path: 'policy/:type',
          name: 'Policy',
          component: Policy,
        },
      ],
    },
    {
      path: '/mypage',
      name: 'Mypage',
      component: Mypage,
    },
    {
      path: '/video',
      name: 'Video',
      component: Video,
    },
    { path: '*', redirect: '/' },
  ],
});

router.beforeEach((to, from, next) => {
  const baseURL = window.location.origin;

  if (!sessionStorage.accessToken) {
    if (to.path === '/') {
      window.location.href = `${baseURL}/auth/login`;
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
